import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=85def3b0&scoped=true&"
import script from "./cardList.vue?vue&type=script&lang=js&"
export * from "./cardList.vue?vue&type=script&lang=js&"
import style0 from "./cardList.vue?vue&type=style&index=0&id=85def3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85def3b0",
  null
  
)

export default component.exports